/**
 * Created by Jonas Wålekvist on 2018-01-25.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Power1, TimelineLite, TimelineMax, TweenLite} from "gsap"
import {DungeonQuestLayerConfig} from "../../config/DungeonQuestLayerConfig";
import {MaskCreator} from "../../utils/MaskCreator";
import {DungeonQuestGameAssets} from "../DungeonQuestGameAssets";


export class DungeonQuestReelAreaAttentionView extends BaseView {
    private _loop:TimelineMax | null;
    private _backgroundMask:PIXI.Graphics;
    private _layer:ScalableLayer;
    private _hideAnimation:TimelineLite | null;
    private _attentionAnimationLeft:TimelineSprite;
    private _attentionAnimationRight:TimelineSprite;
    private _maskLandscapePos:PIXI.Point;


    constructor() {
        super(ResourcesGroupName.MAIN);
        this._layer = StageManager.getLayer(DungeonQuestLayerConfig.REEL_ATTENTIONS.name);
        this._layer.addChild(this);
    }


    protected onResize(resizeData:IResizeData):void {
        //this.position.y = resizeData.orientation == Orientation.PORTRAIT ? -240 : 0;

        if(resizeData.orientation == Orientation.PORTRAIT) {
            const value = Math.ceil(resizeData.right / this._layer.scale.x);
            const margin = (720 - value) * 0.5;

            this._backgroundMask.width = Math.max(720, value);
            this._backgroundMask.x = margin;
            this._attentionAnimationLeft.position.x = margin;
            this._attentionAnimationRight.position.x = 720 + Math.abs(margin);
        } else {
            this._backgroundMask.width = 720;
            this._backgroundMask.x = 0;
            this._attentionAnimationLeft.position.x = 0;
            this._attentionAnimationRight.position.x = 720;
        }

    }

    protected initAnimations():void {
        this._attentionAnimationLeft = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.NEAR_WIN_DIVIDER_SIDE));
        this._attentionAnimationLeft.anchor.set(1, 0);
        this._attentionAnimationLeft.position.set(0, -10);
        this._attentionAnimationLeft.scale.set(-1, 1);
        this._attentionAnimationLeft.blendMode = PIXI.BLEND_MODES.ADD;


        this._attentionAnimationRight = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.NEAR_WIN_DIVIDER_SIDE));
        this._attentionAnimationRight.anchor.set(1, 0);
        this._attentionAnimationRight.position.set(720, -10);
        this._attentionAnimationRight.scale.set(1, 1);
        this._attentionAnimationRight.blendMode = PIXI.BLEND_MODES.ADD;


        this._backgroundMask = MaskCreator.createSymbolAreaMaskGraphics();
        this._backgroundMask.pivot.set(0, Math.ceil(this._backgroundMask.height * 0.72));
        this._backgroundMask.position.set(0, Math.ceil(this._backgroundMask.height * 0.72));


        this.addChild(this._attentionAnimationLeft);
        this.addChild(this._attentionAnimationRight);
        this.addChild(this._backgroundMask);
        this.mask = this._backgroundMask;
        this.alpha = 0;
    }

    private addTint(color:number) {
        this._attentionAnimationLeft.tint = color;
        this._attentionAnimationRight.tint = color;
    }

    public getShowGlow(duration:number = 0.3, color:number = 0xffffff):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => this.addTint(color),
            () => this._backgroundMask.scale.y = 0,
            () => this.startLoop()
        ]);
        tl.add([
            new TweenLite(this, duration * 0.4, {alpha : 1}),
            new TweenLite(this._backgroundMask.scale, duration, {y : 1, ease : Power1.easeOut})
        ]);


        return tl;
    }

    public getHideGlow(duration:number = 0.3):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this, duration, {alpha : 0}));
        tl.add(() => this.stopLoop());
        this._hideAnimation = tl;
        return tl;
    }

    private startLoop() {
        this.stopLoop();
        this._loop = new TimelineMax({repeat : -1});
        this._loop.add([
            this._attentionAnimationLeft.getAnimation(),
            this._attentionAnimationRight.getAnimation()
        ]);
    }

    private stopLoop() {
        if(this._loop) {
            this._loop.pause(0);
            this._loop.kill()
        }

        this._loop = null;

        if(this._hideAnimation) {
            this._hideAnimation.kill()
        }

        this._hideAnimation = null;

    }
}